
<div :class="['container', {'is-visible': visible }, {'is-sticky': sticky }]">
  <div class="prompt">
    <div class="prompt__left">
      <p class="prompt__title">{{ article.title }}, <span class="month-and-year">{{ article.month }} {{ article.year }}</span></p>
      <p class="mobile-prompt-title">{{ truncatedTitle }} <span class="month-and-year">{{ article.month }} {{ article.year }}</span></p>
    </div>

    <div class="prompt__right">
      <button v-if="article.report_type == 'onsite_leadcapture'" type="button" class="button button--filled--blue" @click="triggerForm">Download <span class="report">Report</span></button>
      <button v-if="article.report_type == 'external_link'" type="button" class="button button--filled--blue" @click="triggerExternalLink">View <span class="report">Report</span></button>
      <button v-if="article.report_type == 'onsite_noleadcapture'" type="button" class="button button--filled--blue" @click="triggerDownload">Download <span class="report">Report</span></button>        
    </div>
  </div>
</div>
